<template>
  <div class="menu-box flex">
    <div class="flex-1 menu-item flex-row-center-center">
      <span class="menu-text" @click="handleSelect" :class="{'menu-active': activeId === 'home'}">网站首页</span>
    </div>
    <div v-for="item in menus" :key="item.id" class="flex-1 menu-item flex-row-center-center" :class="{'menu-active': activeId === item.id}">
      <span class="menu-text" @click="handleSelect(1, item)">{{item.name}}</span>
      <div class="sub-menu-list">
        <div class="sub-menu-wrap">
          <div v-for="child in item.children" :key="child.id" class="sub-menu-item">
            <span class="sub-menu-text"  @click="handleSelect(2, child)">{{child.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from "@/config/menus";
export default {
  name: "Nav",
  data() {
    return {
      activeId: "",
      menus: menus.filter((item) => item.id !== "003" && !item.meta?.hidden),
    };
  },
  mounted() {
    this.activeId = sessionStorage.getItem("activeId");
    if (!this.activeId) {
      this.$router.push("/");
    }
  },
  watch: {
    $route: {
      // immediate: true,
      handler(v) {
        this.setActiveId(v);
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        })
      },
    },
  },
  methods: {
    handleSelect(level, menu) {
      if (level === 1) {
        this.$router.push(`/index/lists/${menu.id}`);
        return;
      }
      if (level === 2) {
        this.$router.push(`/index/lists/${menu.id}`);
        return;
      }
      this.$router.push("/");
    },
    setActiveId(route) {
      if(route) {
        const menuId = route.params?.menuId || route.query?.linkMenuId || ""
        if(route.name === "home" || menuId) {
          this.activeId = route.name === "home" ? "home" : menuId.substring(0, 3);
          sessionStorage.setItem("activeId", this.activeId);
        } else if(route.name === "search") {
          this.activeId = "local001";
          sessionStorage.setItem("activeId", this.activeId);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-box {
  width: 1005px;
  height: 40px;
  margin: 0 auto;
  padding: 0 8px;
  background: #0268b3;
  color: #fff;
  position: relative;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  .menu-active {
    background: #33a6dc;
  }
  .menu-item {
    text-align: center;
    cursor: pointer;
    position: relative;
    &:hover {
      background: #33a6dc;
      .sub-menu-list {
        height: 300px;
      }
    }
    &:last-child {
      .menu-text {
        border-right: none;
      }
    }
    .menu-text {
      width: 100%;
      height: 100%;
      line-height: 40px;
      border-right: solid 1px #4e95c9;
      box-sizing: border-box;
    }
    .sub-menu-list {
      position: absolute;
      top: 40px;
      left: 0;
      width: 100%;
      color: #fff;
      box-sizing: border-box;
      overflow: hidden;
      transition: height 0.2s;
      height: 0;
      font-size: 12px;
      line-height: 30px;
      z-index: 99;
      .sub-menu-wrap {
        width: 100%;
        background: #33a6dc;
        .sub-menu-text {
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
